import { gql, TypedDocumentNode } from '@apollo/client';

import { PostsResponse } from '@shared/components/magazin/types';

export const GET_GHOST_POSTS: TypedDocumentNode<{ getGhostPosts: PostsResponse }> = gql`
  query getGhostPosts(
    $page: Float
    $category: String
    $subcategory: String
    $limit: Float
    $order: String
    $q: String
    $author: String
    $jobPositionJobTitles: [String!]
    $contentType: String
    $featured: Boolean
  ) {
    getGhostPosts(
      page: $page
      category: $category
      subcategory: $subcategory
      limit: $limit
      order: $order
      q: $q
      author: $author
      jobPositionJobTitles: $jobPositionJobTitles
      contentType: $contentType
      featured: $featured
    ) {
      total
      posts {
        id
        title
        slug
        featureImage
        featureImageAlt
        excerpt
        publishedAt
        category
      }
    }
  }
`;
